
import { Vue } from "vue-class-component";
export default class SetupChallenge extends Vue {}
